/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader, useModal } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext,useState, useEffect } from 'react';
// import StandardizeAddressPopUp from 'ent-capability-quoteandbind-common-react/components/StandardizeAddressPopUp/StandardizeAddressPopUp';
import { TWIAPhoneComponent, TWIAAddressComponent, TWIAEmailComponent } from 'twia-capability-address-component';
import addressControl from 'twia-capability-address-component/util/addressControl';
import { GatewayRenewalService as RenewalService } from 'gw-capability-gateway-policyrenewal';
import PrintDocumentUtil from '../../util/PrintDocumentUtil';
import metadata from './CoverageSummaryPage.metadata.json5';
import styles from './CoverageSummaryPage.module.scss';
import Offerings from '../../components/Quote/Offerings/Offerings';
import AddressStandardizationService from '../../../../../common/capabilities/twia-capability-addressstandaradization/services/AddressStandardizationService';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import StandardAddressValidationUtil from '../../util/StandardAddressValidationUtil';


function TWIACoverageSummaryPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { wizardData: submissionVM, updateWizardData } = props;
    const [isLoading, setIsLoading] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [accountHolderVM, setAccountHolderVM] = useState(submissionVM.baseData.accountHolder);
    const [addressVM, setAddressVM] = useState(submissionVM.baseData.accountHolder.primaryAddress);
    const [addressVMPolicy, setAddressVMPolicy] = useState(submissionVM.baseData.policyAddress);
    const { showAlert, showConfirm, showModal } = useModal();
    const [showErrors, setShowErrors] = useState(false);
    const { authHeader } = useAuthentication();
    const country = _.get(accountHolderVM, 'primaryAddress.country.value.code');
    const isPerson = _.get(submissionVM, 'baseData.accountHolder.subtype.value') === 'Person';
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { isComponentValid, initialValidation, onValidate } = useValidation('TWIACoverageSummaryPage');
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const xPortal = 'PE';
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const selectedUWCompany = isRenewal ? _.get(submissionVM, 'lobData.homeowners.associationName_TWIA.value.code') : _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
    const ceUserName = _.get(submissionVM, 'bindData.registeredCEUsername_TWIA.value');
    const autoPayEnabled = _.get(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value');
    const mailingAddressTypeCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.AddressType').getCode('mailingExt');
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'CoverageSummaryPage');
        }
    }, [isComponentValid, onValidate]);
    
    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);
    
    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);
        try {
            _.set(submissionVM.value, 'bindData.isAutoPayEnabled_TWIA', false);
            // DE18079
            _.set(submissionVM, 'baseData.accountHolder.primaryAddress.addressType.value', mailingAddressTypeCode);
            _.set(submissionVM, 'lobData.homeowners.coverables.yourHome.primaryAddress_TWIA.addressType.value', mailingAddressTypeCode);
            _.set(submissionVM, 'baseData.policyAddress.addressType.value', mailingAddressTypeCode);
            _.set(submissionVM.value, 'bindData.contactEmail',submissionVM.value.baseData.accountHolder.emailAddress1);
            resetElectronicPaymentData();
            if (isRenewal) {
                submissionVM.value = await RenewalService.updateQuotedRenewal(
                    [submissionVM.value],
                    authHeader
                )
            } else {
                submissionVM.value = await LoadSaveService.updateQuotedSubmission(
                    submissionVM.value,
                    authHeader
                );
            }
        updateWizardData(submissionVM);
        setIsAddressEdited(false);
            return submissionVM;
        } catch (error) {
            console.log(error)
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            return false;
        }
    }, [invalidComponent, submissionVM, mailingAddressTypeCode, resetElectronicPaymentData,
        isRenewal, updateWizardData, authHeader, LoadSaveService, showAlert]);

    const updateSubmissionVM = useCallback((value) => {
        setAccountHolderVM(value);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);
    
    // DE15699
    const updatePolicyAddressVM = useCallback((value) => {
      //  _.set(submissionVM, 'baseData.accountHolder.primaryAddress', value);
        _.set(submissionVM, 'baseData.policyAddress.value', value);
        submissionVM.baseData.policyContactDetails_TWIA.children[0].primaryAddress = value;
        setDisablity(value);
        if(value.isValidated_Ext === true || value.isOverridden_Ext === true) {
            setIsAddressEdited(false);
        }
        updateWizardData(submissionVM);
    }, [setDisablity, submissionVM, updateWizardData]);
    
    const quotePrintDocument = useCallback(async () => {
        setIsLoading(true);
        await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader);
        setIsLoading(false);

    }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });
    
    useEffect(() => {
        getPCConstants();
        setAccountHolderVM(submissionVM.baseData.accountHolder);
        setAddressVMPolicy(submissionVM.baseData.policyAddress);
        if (submissionVM.baseData.policyAddress?.isOverridden_Ext?.value
            && !submissionVM.baseData.policyAddress?.isOverriddenInternally_Ext?.value 
            && submissionVM.baseData.policyAddress?.country?.value.code === 'US') {
            StandardAddressValidationUtil.setNotValidated(submissionVM.baseData.policyAddress.value);
            setIsAddressEdited(true); //DE18415
        }
    }, []);

    const generateOverrides = useCallback(() => {
        const offerings = _.get(submissionVM, 'lobData.homeowners.offerings.value');
        const overrides = offerings.map((_section, index) => ({
            [`offeringDetails${index}`]: {
                submissionVM,
                isCoverageSummaryScreen : true
            },
        }));

        return Object.assign({}, ...overrides);
    }, [submissionVM]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        emailAddressComponent: {
            accountHolderVM, updateSubmissionVM, authHeader, showErrors, findInvalidComponent, onValidate, ceUserName, autoPayEnabled,
            companyType : selectedUWCompany
        },
        // DE15699
        mailingAddressComponent: {
            addressVM:addressVMPolicy,updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, 
            companyType: selectedUWCompany,
            pcConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            xPortal
        },
        phoneNumberComponent: {
            accountHolderVM, updateSubmissionVM, isPerson, showErrors, findInvalidComponent, onValidate
        },
		offeringDetails: {
            wizardData: submissionVM,
            updateWizardData
        },
        totalPremium: {
            value: {
                amount: _.get(submissionVM, 'quoteData.offeredQuotes.value[0].premium.total.amount'),
                currency: "USD"
            }
        },
        propertyAddress: {
            value: _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.displayLocationAddressDTO_TWIA.displayName.value')?.split(":")[1]
        },
        ...generateOverrides(),
    };

    const resolvers = {
        resolveComponentMap: {
			offeringComponent: Offerings,
			phoneComponent: TWIAPhoneComponent,
            emailComponent: TWIAEmailComponent,
            addressComponent: TWIAAddressComponent
			},
        resolveCallbackMap: {
            quotePrintDocument
        },
        resolveClassNameMap: { wizardStyles, styles },
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            disableNext={isButtonDisabled || isAddressEdited}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIACoverageSummaryPage.propTypes = wizardProps;
export default TWIACoverageSummaryPage;
